import React from "react";

const SDSRequest = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default SDSRequest;